const TRUSTED_KATEX_COMMANDS = new Set(["\\htmlClass", "\\htmlId"]);

export function isTrustedKatexCommand(context) {
  return TRUSTED_KATEX_COMMANDS.has(context.command);
}
